import { isLocalhost } from '@web_opxp/features';
import takeRight from 'lodash/takeRight';
import * as HistoryService from './historyService';

function trimLeadingSpaces(str: string): string {
  while (str.startsWith(' ')) {
    str = str.substring(1);
  }
  return str;
}

export function getCookie(cName: string) {
  const name = cName + '=';
  // get the full cookies string
  const decodedCookie = decodeURIComponent(document.cookie);
  // split into single cookies strings
  const cookies = decodedCookie.split(';');
  // search for cookie with given name
  for (const cookie of cookies) {
    // trim whitespaces from start
    const trimmedCookie = trimLeadingSpaces(cookie);
    // detect if cookie starts with requested name
    if (trimmedCookie.startsWith(name)) {
      return trimmedCookie.substring(name.length, trimmedCookie.length);
    }
  }
  return '';
}

export const COOKIE_DURATION_MS = 365 * 24 * 60 * 60 * 1000;

function getDomain() {
  // get domain from current url
  const domain = window.location.hostname;
  // split in parts
  const parts = domain.split('.');
  // take last two domains
  const lastParts = takeRight(parts, 2);
  // compile back to string
  return lastParts.join('.');
}

export function setCookie(cName: string, cValue: string, disableSameSite = false) {
  const cookieValue = encodeURIComponent(cValue);
  const attributes: string[] = [];
  const expirationDate = new Date(Date.now() + COOKIE_DURATION_MS);
  attributes.push('expires=' + expirationDate.toUTCString());
  attributes.push('domain=' + getDomain());
  attributes.push('path=/');
  if (!isLocalhost) {
    attributes.push('Secure');
    if (!disableSameSite) {
      attributes.push('SameSite=Strict');
    }
  }
  if (disableSameSite) {
    attributes.push('SameSite=None');
  }
  const newCookie = `${cName}=${cookieValue}; ` + attributes.join('; ');
  document.cookie = newCookie;
  return newCookie;
}

export const COOKIE_LP_PREFIX = 'nn_ads_landingpage_data';
export const lpCookieName = (name: string) => `${COOKIE_LP_PREFIX}[${name}]`;

export function saveLpTrackingCookies(
  campaign: string | null,
  meta: string | null,
  keyword: string | null,
  adGroup: string | null
) {
  if (campaign) {
    setCookie(lpCookieName('campaign'), campaign, true);
  }
  if (meta) {
    setCookie(lpCookieName('campaign_meta'), meta, true);
  }
  if (keyword) {
    setCookie(lpCookieName('campaign_keyword'), keyword, true);
  }
  if (adGroup) {
    setCookie(lpCookieName('ad_group'), adGroup, true);
  }
}

export function detectLandingPageTracking() {
  const searchParams = HistoryService.getCurrentSearchParams();
  // read tracking parameters
  const campaign = searchParams.get('lp-c');
  const meta = searchParams.get('lp-m');
  const keyword = searchParams.get('lp-k');
  const adGroup = searchParams.get('lp-a');
  if (!campaign && !meta && !keyword && !adGroup) {
    return;
  }
  // save values to cookies
  saveLpTrackingCookies(campaign, meta, keyword, adGroup);
  // remove parameters from url
  searchParams.delete('lp-c');
  searchParams.delete('lp-m');
  searchParams.delete('lp-k');
  searchParams.delete('lp-a');
  HistoryService.updateSearchParams(searchParams);
}
